import axios from 'axios'
import { ElMessage } from 'element-plus'
import router from '@/router'

const service = axios.create({
    baseURL: 'https://hub.huizeqifu.com/home', // 这里配置 API 基础路径 c
    timeout: 5000 // 超时时间
})

// 请求拦截器
service.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token')
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
        }
        return config
    },
	
    (error) => Promise.reject(error)
)

// 响应拦截器
service.interceptors.response.use(
    (response) => {
        const res = response.data
        const authHeader = response.headers['authorization']
		console.log('响应', response.headers)
        // 👇 判断是否是导出类型
        if (response.config.responseType === 'blob') {
            return response;
        }
        
        if (authHeader) {
            console.log('响应的 Authorization:', authHeader)
            localStorage.setItem('token', authHeader)
        }

        if (res.status !== true) {
            if (res.code === 401) {
                ElMessage.error('登录已过期，请重新登录')
                localStorage.removeItem('token')
                router.push('/login') // ✅ 直接使用 router.push()
            }
            ElMessage.error(res.message)
            return Promise.reject(new Error(res.message || 'Error'))
        }
        console.log('响应', res)
        return res
    },
    (error) => {
        if (error.response?.status === 401) {
            ElMessage.error('登录已过期，请重新登录')
            localStorage.removeItem('token')
            router.push('/login') // ✅ 直接使用 router.push()
        } else {
            ElMessage.error(error.message || '网络请求错误')
        }
        return Promise.reject(error)
    }
)

export default service
